import { MultiselectFilter, FilterRowTextLabel } from '../generic';
import { Filter, FilterOption } from '@model/iceberg';
import { TestId } from '@components/test-ids';
import React from 'react';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';

/* ********** *
 *    Types   *
 * ********** */
export interface MultiselectFilterProps {
  filter: Filter;
  onChange: (payload: Filter) => void;
  visibleNumberOfFilters?: number;
  showCount?: boolean;
  testId?: string;
  isLeftFilter?: boolean;
}

/* *********** *
 *    Styles   *
 * *********** */

const Count = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.attribute as any),
  marginLeft: theme.custom.spacing.xSmall
}));

export const CheckboxFilter = (props: MultiselectFilterProps) => {
  const { showCount = true } = props;

  const getForwardedName = (name: string, count: number): JSX.Element => {
    const BracketsRegex = /^(.*)\((.*)\)(.*)$/;
    if (BracketsRegex.test(name)) {
      const [_, main, brackets, post] = BracketsRegex.exec(name) || [];
      return (
        <>
          {main}
          <span css={{ fontSize: 'smaller' }}>({brackets.toLowerCase()})</span>
          {post}
        </>
      );
    }
    return (
      <>
        {name} {!!count && showCount && <Count>({count})</Count>}
      </>
    );
  };
  const renderLabel: (filterOption: FilterOption) => JSX.Element = ({ name, count, selected }: FilterOption) => (
    <FilterRowTextLabel
      data-testid={TestId.multiselectFilters.textFilterLabel}
      isSelected={selected}
      available={!!count}
    >
      {getForwardedName(name, count)}
    </FilterRowTextLabel>
  );

  return <MultiselectFilter {...props} renderLabel={renderLabel} />;
};
